import React from "react";
import "../../src/index.css";
export const About = (props) => {
  return (
    <div id="about" className="about">
      <div className="container">
        <div className="row">
        <img
                  className="header-logo"
                  src="img/logo/hack 4 good no bg.png"
                  alt="HTB"
                />          <div className>
            <div className="about-text">
              <h2>About Hack4Good </h2>
              <p>
              Hack4Good, an innovative platform where coding meets compassion and creativity meets community. Flagship Hackathon event of the IEEE Signal Processing Society (SPS) Kerala Chapter,Powered by IEEE Humanitarian Technologies Board ,the satellite event for ICASSP 2025 organized by the IEEE SPS Kerala Chapter, Hack4Good is a dynamic Three phased Hackathon aimed at leveraging technology to address real-world challenges and advance the United Nations' Sustainable Development Goals (SDGs). At Hack4Good, we believe in the transformative power of technology to drive positive change. Our mission is to provide a space where developers of all levels - from seasoned professionals to budding enthusiasts - can come together to collaborate, learn, and innovate. The aim is to find good effective solutions for problems that are being obstacles to Sustainability. Hackathon is divided into three phases,with first two phases being online and Final phase will be a 24 hour Offline Hackathon. Top deserving 40 teams are to be selected into the Final phase and will be provided with Mentors for mentorship and guidance.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <img src="img/logo/sps kc png.png" alt="" id="sps"/>
          <div className>
            <div className="about-text">
              <h2>About IEEE SPS Kerala Chapter</h2>
              <p>
              The IEEE Signal Processing Society (SPS) Kerala Chapter is a lively, close-knit community, honored globally as the Best Chapter of the Year among all IEEE SPS branches worldwide. Our team includes 23 dedicated student leaders and 17 seasoned professionals—three of them VOLT graduates—all working under the guidance of an advisory body that brings clarity and direction to our vision. Together, we shape every event with purpose and creativity, striving to leave a genuine impact on this beautiful world, driven by something so uniquely human. Our chapter’s dedication is evident in the flourishing SPS student branches across Kerala, where we build lasting connections and share knowledge through regular collaborations. We’ve celebrated wins in prestigious ICIP and ICASSP video-making competitions, and some of our members are now part of the organizing team for ICASSP 2025, reflecting a commitment that reaches far beyond our region. Working hand in hand with other IEEE section chapters, we are building a network that reaches from the grassroots of Kerala to the world. Our chapter is more than a community—it’s a place where ideas flourish, people engage, and every endeavor holds a lasting purpose. Yes, that’s what we are: a family.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <img src="img/logo/humtn logo png.png" alt="" />
          <div className>
            <div className="about-text">
              <h2>About IEEE HTB</h2>
              <p>
                The IEEE Humanitarian Technologies Board (HTB) inspires and
                empowers IEEE volunteers around the world carrying out and
                supporting impactful humanitarian technology activities at the
                local level. The IEEE HTB mission is to support impactful and
                ethically informed volunteer-led initiatives, programs and
                projects, and mutually beneficial partnerships, as well as to
                inform policy formulation that harness technology and innovation
                to address societal challenges (including disaster recovery) in
                a responsive, effective, and sustainable way.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <img src="img/logo/nitc.jpeg" alt="" />
          <div className>
            <div className="about-text">
              <h2>About IEEE NITC SB </h2>
              <p>
              The IEEE Student Branch at NIT Calicut (NITC), established in 1985, has been pivotal in fostering technological innovation, leadership, and community engagement among students. Over the years, it has grown into a significant force in both the IEEE community and local society, organizing impactful events and initiatives that merge technology with societal needs. Notable activities include Slash Key 3.0, a state-wide technical event, and a symposium celebrating 75 years of the Circuits and Systems Society (CASS). The branch's humanitarian efforts have been exemplary, such as providing 300 emergency LED lamps during the Wayanad landslide relief and developing an off-grid solar-powered digital library for Anakkampoyil, enhancing educational access while promoting renewable energy. These initiatives reflect the branch’s commitment to innovation, interdisciplinary collaboration, and service to society.
              </p>
            </div>
          </div>
        </div>

      
      </div>
    </div>
  );
};
